import { IconRenderer } from 'braid-design-system';
import React, { type ReactElement } from 'react';

import IconSeekPassSVG from './IconSeekPassSVG';

export const IconSeekPass = (): ReactElement => (
  <IconRenderer>
    {({ className }) => <IconSeekPassSVG className={className} />}
  </IconRenderer>
);
